<template>
  <div class="home">
    <!-- <div class="messType" v-show="isReconnecting">正在尝试链接服务器，尝试次数{{ useWork.reconnectAttempts }}</div> -->
    <!-- {{ work.eventLogs }} -->
    <router-view  v-if="store.user.id"/>
  </div>
</template>
<script setup>
  import { useSocket } from "@/stores/index";
  import { useWork } from "@/stores/work";
	import { userInfo,getOrderType} from '@/api/index'
  
  import { onMounted,onUnmounted,computed} from 'vue';
  const store=useSocket(),work=useWork()
  import { getQueryString } from '@/assets/js/index';
  import axios from "axios";
  import { baseURL  } from '@/config'
  const isReconnecting=computed(()=>{
    return work.isReconnecting
  })

  const init=async()=>{
    setTimeout(async()=>{
      const userData=await userInfo({wxappId:work.auth.wxappId})
      console.log(userData)
      await store.setUser(userData)
      if(getQueryString('code')){
        getOrderType({type:'order_type',wxappId:work.auth.wxappId}).then(res=>{
          store.setOrderType(res)
        })
      }
      if(store.user.id){
        await work.init()
      }
    },10)
  
  }
  onMounted(async() => {
    try{
      if(getQueryString('code')){
        const form={
          wxappId:work.auth.wxappId,
        }
        const nform={
          token:getQueryString('token'),
          uuid:getQueryString('uuid'),
          supplierCode:getQueryString('code'),
        }
        for(let val in nform){
          if(nform[val]){
            form[val]=nform[val]
          }
        }
        axios({
          method: 'get',
          url: baseURL + "app-api/im/member-user/login",
          params: form,
        }).then(async res=>{
          if(res.data.code==0){
            work.setToken(res.data.data)
            await init()
          }
        })
      }
      else{
        work.setToken(getQueryString('token'))
        await init()
      }
     

		}catch(e){
      console.log(111)
			alert("加入群聊失败")
		}
  })
  
  onUnmounted(()=>{
    work.destroy()
  })
</script>
<style lang="scss" scoped>
.home{
  height: 100vh;
  width: 100%;
  overflow: hidden;
}
.messType{
  transition-duration: 500ms;
  position: relative;
  color:#666;
  text-align: center;
  font-size: 12px;
  padding:6px 0;
}
.islike1,.islike2{
  background: #f30000;
  color:#fff;
}
.islike3{
  background: #ffd881;
  color:#fff;
}
</style>